import { useState } from "react";
import Button from "../../../ui/Button";
import { customerFormatForAttachment, useGetAllCustomerQuery } from "../../../utils/customer.utils";
import { displayNumber } from "../../../utils/number.utils";
import TablePagination from "../../../ui/Table/TablePagination";
import SearchedCustomerProfile from "./SearchedCustomerProfile";
import { useNavigate } from "react-router-dom";
import { arrayMap } from "../../../utils/array.utils";

export default function SearchCustomer({ step, setStep }) {
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [isSearched, setIsSearched] = useState(false);
  const [searchText, setSearchText] = useState(step.customerSearch ?? "");
  const navigate = useNavigate();

  const { isFetching: loading, data } = useGetAllCustomerQuery({
    query: `?page=${currentPage}&size=${pageSize}&search=${step.customerSearch}`,
    options: {
      enabled: !!step.customerSearch
    }
  });

  function handleBack() {
    navigate("/quotation-list");
  }

  function handleNext(data) {
    setStep((prev) => ({
      ...prev,
      currentStep: prev.currentStep + 1,
      customer: data
    }));
  }

  function onSearch() {
    setStep((prev) => ({ ...prev, customerSearch: searchText }));
    setIsSearched(true);
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  const searchLength = data?.data?.length;
  const totalPage = data?.last_page === 1 && data?.total === 0 ? 0 : data?.last_page;

  return (
    <div>
      {/* search panel */}
      <div>
        <p className="text-center">Customer Search</p>
        <input
          type="text"
          className="form-control text-center"
          placeholder="Enter name or mobile or customer id"
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
          onKeyDown={handleKeyDown}
        />

        <div className="text-center mt-3">
          <Button onClick={handleBack} color="info" name="Back" />{" "}
          <Button onClick={onSearch} name={loading ? "Searching..." : "Search"} />
        </div>
      </div>

      {!!searchLength && (
        <p style={{ fontWeight: 500 }}>
          <i>{displayNumber(searchLength)} Customer found</i>
        </p>
      )}

      {/* search result */}
      {searchLength ? (
        <>
          {arrayMap(data?.data, (item, index) => {
            const customerData = customerFormatForAttachment(item);

            return (
              <SearchedCustomerProfile data={customerData} key={index}>
                <div className="col-12">
                  <div className="text-center">
                    <Button onClick={() => handleNext(customerData)} name="Next" />
                  </div>
                </div>
              </SearchedCustomerProfile>
            );
          })}

          <div className="mt-3">
            <TablePagination
              totalPage={totalPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </>
      ) : isSearched && !loading ? (
        "No Data"
      ) : (
        ""
      )}
    </div>
  );
}
